module.exports = __webpack_public_path__ + "face_landmark_68_tiny_model-weights_manifest.json";